import React from 'react';
import './LeaderboardEntry.css';

const LeaderboardEntry = ({ entry, index, isCurrentUser }) => {
  const { rank, user_id, tasks_solved, tied_rank } = entry;

  // Determine rank display and styling
  const getRankDisplay = () => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return `#${rank}`;
  };

  const getRankClass = () => {
    if (rank === 1) return 'rank-gold';
    if (rank === 2) return 'rank-silver';
    if (rank === 3) return 'rank-bronze';
    return 'rank-normal';
  };


  // Generate user avatar or initials
  const getUserDisplay = () => {
    // Simple initials from user_id
    const initials = user_id
      .split(/[^a-zA-Z0-9]/)
      .map(part => part.charAt(0).toUpperCase())
      .filter(char => char.match(/[A-Z0-9]/))
      .slice(0, 2)
      .join('');

    return initials || user_id.charAt(0).toUpperCase();
  };


  return (
    <div className={`leaderboard-entry ${isCurrentUser ? 'current-user' : ''} ${index % 2 === 0 ? 'even' : 'odd'}`}>
      {/* Rank */}
      <div className={`rank ${getRankClass()}`}>
        <span className="rank-display">{getRankDisplay()}</span>
        {tied_rank && <span className="tied-indicator" title="Tied rank">≈</span>}
      </div>

      {/* User */}
      <div className="user-info">
        <div className="user-avatar">
          {getUserDisplay()}
        </div>
        <div className="user-details">
          <span className="user-id">{user_id}</span>
          {isCurrentUser && <span className="current-user-badge">You</span>}
        </div>
      </div>

      {/* Tasks solved */}
      <div className="tasks-solved">
        <span className="tasks-number">{tasks_solved}</span>
        <span className="tasks-label">tasks</span>
      </div>

    </div>
  );
};

export default LeaderboardEntry;